import type { JournalEntry, journalEntryMethods } from '@/db/journal'
import type { Person, personMethods } from '@/db/schemas'
import type { RxCollection, RxDatabase } from 'rxdb'
import { inject, shallowRef, type InjectionKey, type ShallowRef } from 'vue'

export type Collections = {
  entries: RxCollection<JournalEntry, typeof journalEntryMethods>
  persons: RxCollection<Person, typeof personMethods>
}

export type DatabaseType = RxDatabase<Collections>

export const dbKey = Symbol() as InjectionKey<ShallowRef<DatabaseType | undefined>>

export function injectDatabase() {
  return inject(dbKey) || shallowRef<DatabaseType | undefined>(undefined)
}
